<template>
  <div :class="['modal', 'modal_type_full']">
    <div
      class="modal__box"
      :style="boxStyle || { width: fullWidth ? '100%' : '' }"
      ref="modalBox"
    >
      <slot name="title"></slot>
      <div v-if="hasButtonClose" @click="$emit('close')" class="modal__close" />
      <div class="modal__content" :style="contentStyle">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    boxStyle: { type: [Object, String], default: () => ({}) },
    contentStyle: { type: [Object, String], default: () => ({}) },
    fullWidth: { type: Boolean, default: false },
    hasButtonClose: { type: Boolean },
    info: { type: String, default: '' },
  },
  mounted() {
    this.$emit('mount', this.$refs.modalBox);
  },
};
</script>

<style lang="scss" scoped>
@import './Modal';
</style>
